/* Forms - Select - Desktop - Max Height */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectMaxHeight( select2 , maxHeight ) {

    /* Setup */
    var offset = 0;
    var margin = 15;
    var select2Results = select2.find( '.select2-results' );
    var select2Options = select2.find( '.select2-results > ul.select2-results__options' );

    /* Adjust Max Height */
    maxHeight = maxHeight - offset - margin;

    /* Reset Height */
    select2Options.css( 'max-height' , '' );
    select2Results.css( 'max-height' , '' );

    /* Remove Class */
    select2.removeClass( 'select2-scroll' );

    /* Wait For Redraw */
    setTimeout(function(){

        /* If Not Enought Height */
        if ( select2Results.height() > maxHeight ) {

            /* Set Max Height */
            select2Options.css( 'max-height' , maxHeight );
            select2Results.css( 'max-height' , maxHeight );

            /* Add Class */
            select2.addClass( 'select2-scroll' );

        }

    } , 1 );

}

/* Forms - Select - Desktop - Direction */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectDirection( select2 ) {

    /* Setup */
    var minDistance = 200;
    var select2Dropdown = select2.find( '.select2-dropdown' );
    var select2Rendered = select2.find( '.select2-selection__rendered' );

    /* Calculate Pixels Above Select */
    var heightAboveSelect = select2Rendered.offset().top - jQuery( window ).scrollTop();

    /* Calculate Pixels Below Select */
    var heightBelowSelect = jQuery( window ).innerHeight() - heightAboveSelect - select2Rendered.outerHeight();

    /* If Below Minimum Distance */
    if ( heightBelowSelect < minDistance && heightAboveSelect > heightBelowSelect ) {

        /* Set Above */
        select2.removeClass( 'select2-container--below' ).addClass( 'select2-container--above' );
        select2Dropdown.removeClass( 'select2-dropdown--below' ).addClass( 'select2-dropdown--above' );

        /* Return Max Height */
        return heightAboveSelect;

    } else {

        /* Set Below */
        select2.removeClass( 'select2-container--above' ).addClass( 'select2-container--below' );
        select2Dropdown.removeClass( 'select2-dropdown--above' ).addClass( 'select2-dropdown--below' );

        /* Return Max Height */
        return heightBelowSelect;

    }

}

/* Forms - Select - Desktop - Format Options */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectDesktopFormatOptions( state ) {

    /* Setup */
    var option = state.text;

    /* If Icon */
    if ( jQuery( state.element ).data( 'icon' ) !== undefined && jQuery( state.element ).data( 'icon' ) != '' ) {

        /* Add Icon To Option */
        option = '<i style="background-image: url(' + jQuery( state.element ).data( 'icon' ) + ')"></i>' + '<span>' + option + '</span>';

    }

    /* Return Option */
    return option;

}

/* Forms - Select - Desktop - Format Selection */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectDesktopFormatSelection( state ) {

    /* Setup */
    var option = state.text;

    /* If Icon */
    if ( jQuery( state.element ).data( 'icon' ) !== undefined && jQuery( state.element ).data( 'icon' ) != '' ) {

        /* Add Icon To Option */
        option = '<i style="background-image: url(' + jQuery( state.element ).data( 'icon' ) + ')"></i>' + '<span>' + option + '</span>';

    }

    /* Return Option */
    return option;

}

/* Forms - Select - Desktop - Close */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectDesktopClose() {

    /* Setup */
    var select = jQuery( this );

    /* If Has Validation */
    if ( select.hasClass( 'form-validated' ) ) {
        select.valid();
    }

}

/* Forms - Select - Desktop - Open */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectDesktopOpen() {

    /* Setup */
    var select  = jQuery( this );
    var select2 = select.parent().find( '.select2' );

    /* Search Text */
    if ( select.data( 'search' ) !== undefined && select.data( 'search' ) != '' ) {
        select2.find( '.select2-search input' ).attr( 'placeholder' , select.data( 'search' ) );
    }

    /* Direction */
    var maxHeight = ipcrimeFormsSelectDirection( select2 );

    /* Max Height */
    ipcrimeFormsSelectMaxHeight( select2 , maxHeight );

}

/* Forms - Select - Desktop */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsStyleSelectDesktop() {

    /* Load Select 2 */
    jQuery.fn.select2.amd.require( [ 'select2/utils' , 'select2/dropdown' , 'select2/dropdown/attachContainer' , 'select2/dropdown/search' , 'select2/dropdown/closeOnSelect' , 'select2/dropdown/minimumResultsForSearch' ] , function ( Utils , DropdownAdapter , AttachContainer , DropdownSearch , closeOnSelect , minimumResultsForSearch ) {

        /* Custom Adapter For Positioning */
        var CustomAdapter = Utils.Decorate( Utils.Decorate( Utils.Decorate( Utils.Decorate( DropdownAdapter , DropdownSearch ) , AttachContainer ) , closeOnSelect ) , minimumResultsForSearch );

        /* Loop Form Elements */
        jQuery( 'select.form-select' ).each(function( index ) {

            /* Get Select */
            var select = jQuery( this );

            /* Template */
            select.wrap( '<div></div>' );

            /* Move Classes */
            select.parent().attr( 'class' , select.attr( 'class' ) );
            select.removeClass();

            /* Label */
            ipcrimeFormsStyleLabel( select );

            /* Placeholder */
            if ( select.data( 'placeholder' ) !== undefined && select.data( 'placeholder' ) != '' ) {
                select.prepend( '<option></option>' );
                var selected = false;
                select.find( 'option' ).each(function( index ) {
                    if ( jQuery( this ).attr( 'selected' ) ) {
                        selected = true;
                    }
                });
                if ( selected === false ) {
                    select.val( '' );
                }
            }

            /* Search */
            if ( select.data( 'search' ) !== undefined && select.data( 'search' ) != '' ) {
                select.parent().addClass( 'form-select-search' );
            }

            /* Disabled */
            ipcrimeFormsStyleDisabled( select );

            /* Style Select */
            select.select2({
                placeholder: 'Select a Name',
                minimumResultsForSearch: ( select.parent().hasClass( 'form-select-search' ) ? 5 : -1 ),
                width: '100%',
                multiple: false,
                closeOnSelect: true,
                escapeMarkup: function(markup) { return markup; },
                templateResult: ipcrimeFormsSelectDesktopFormatOptions,
                templateSelection : ipcrimeFormsSelectDesktopFormatSelection,
                dropdownAdapter: CustomAdapter

            /* On Open */
            }).on( 'select2:open' , ipcrimeFormsSelectDesktopOpen ).on( 'select2:close' , ipcrimeFormsSelectDesktopClose );

            /* Icon Text */
            setTimeout(function() {

                /* If Icon Text */
                if ( select.data( 'icon-text' ) !== undefined && select.data( 'icon-text' ) != '' ) {

                    /* Icon */
                    var icon = select.parent().find( '.select2-selection__arrow' );

                    /* Add Class */
                    icon.addClass( 'icon-text' );

                    /* Add Text */
                    icon.html( select.data( 'icon-text' ) );

                }

            } , 10 );

        });

    });

}

/* Forms - Select - Mobile */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsStyleSelectMobile() {

    /* Loop Selects */
    jQuery( 'select.form-select' ).each(function( index ) {

        /* Get Select */
        var select = jQuery( this );

        /* Template */
        select.wrap( '<div></div>' );

        /* Move Classes */
        select.parent().attr( 'class' , select.attr( 'class' ) );
        select.removeClass();

        /* Label */
        ipcrimeFormsStyleLabel( select );

        /* Placeholder */
        if ( select.data( 'placeholder' ) !== undefined && select.data( 'placeholder' ) != '' ) {
            select.prepend( '<option value="">' + select.data( 'placeholder' ) + '</option>' );
            var selected = false;
            select.find( 'option' ).each(function( index ) {
                if ( jQuery( this ).attr( 'selected' ) ) {
                    selected = true;
                }
            });
            if ( selected === false ) {
                select.val( '' );
            }
        }

        /* Add Icon */
        select.after( '<i></i>' );

        /* If Icon Text */
        if ( select.data( 'icon-text' ) !== undefined && select.data( 'icon-text' ) != '' ) {

            /* Icon */
            var icon = select.parent().find( 'i' );

            /* Add Class */
            icon.addClass( 'icon-text' );

            /* Add Icon Text */
            icon.html( select.data( 'icon-text' ) );

        }

        /* Disabled */
        ipcrimeFormsStyleDisabled( select );

    });

}

/* Forms - Style Select */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsStyleSelect() {

    /* If Desktop */
    if ( jQuery( 'html' ).hasClass( 'platform-desktop' ) ) {

        /* Style Desktop */
        ipcrimeFormsStyleSelectDesktop();

    /* If Mobile */
    } else {

        /* Style Mobile */
        ipcrimeFormsStyleSelectMobile();

    }

}

/* Forms - Country Select */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsCountrySelect( data ) {

    function compare(a,b) {
	  if (a.FIELD5 < b.FIELD5){
	    return -1;
	  } else if (a.FIELD5 > b.FIELD5) {
	    return 1;
	  } else {
	    return 0;
	  }
	}

	data.sort(compare);

    /* Loop Selects */
    jQuery( 'select.form-select-country' ).each(function( index ) {

        /* Get Select */
        var select = jQuery( this );
        /* get the available countries*/
        var displayCountries;
        if(select.data('countries')){
            displayCountries = select.data('countries').split(',');
        }else{
            displayCountries= -1;
        }

        var selectedItem = select.data( 'selected' );

        /* Empty Select */
        select.html( '' );

        /* Setup */
        var options = '';

        /* Loop Countries */
        jQuery.each( data , function( key , country ) {
            if(displayCountries === -1 || displayCountries.indexOf(country.FIELD1) > -1 || country.FIELD1 === selectedItem){
                /* Build Icon */
                // var icon = 'http://geotree.geonames.org/img/flags18/' + country[ 'FIELD1' ] + '.png';
                var icon = '/media/ims/flags/' + country[ 'FIELD1' ] + '.png';
                /* Create Option */
                options += '<option data-icon="' + icon + '" value="' + country[ 'FIELD1' ] + '">' + country[ 'FIELD5' ] + '</option>';
            }
        });

        /* Populate Select */
        select.html( options );

        /* Selected */
        if ( select.data( 'selected' ) !== undefined ) {
            select.val( select.data( 'selected' ) );
            select.find( 'option[value="' + select.data( 'selected' ) + '"]' ).attr( 'selected' , 'selected' );
        }

    });

}

/* Forms - Select Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsSelectInit() {

    /* Forms - Country Select */
    ipcrimeFormsCountrySelect( countryJSON );

    /* Forms - Style Select */
    ipcrimeFormsStyleSelect();

}
